module.exports = __webpack_public_path__ + "img/garbage.2096033f.svg";